import { useEffect } from "react";

const MAIN_SITE = "https://josfamilylaw.com";

/**
 * Bare component used at the / route.
 * Hard-redirects the browser to the main firm site.
 */
export default function ExternalRedirect({ to = MAIN_SITE } = {}) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return (
    <main
      data-testid="external-redirect"
      className="min-h-screen bg-paper text-ink flex items-center justify-center px-6"
    >
      <div className="text-center">
        <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-gray-600 mb-4">
          Redirecting
        </p>
        <p className="font-display text-3xl text-ink">
          Taking you to{" "}
          <a
            href={to}
            className="text-teal hover:text-ink underline-offset-4 underline transition-colors"
          >
            josfamilylaw.com
          </a>
          …
        </p>
      </div>
    </main>
  );
}
